import { createApi } from '@reduxjs/toolkit/query/react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { decryptData, loadState } from 'utils';

const STORAGE_KEY = 'cayesh_user_loggged';
const storedUser = loadState(STORAGE_KEY);
const token = storedUser?.token;

const axiosBaseQuery = ({ baseUrl } = { baseUrl: '' }) => async ({ url, method, data, headers }) => {
	try {
		const result = await axios({
			url: baseUrl + url,
			method,
			data,
			headers
		});
		return { data: result.data };
	} catch (axiosError) {
		let err = axiosError;
		return {
			error: {
				status: err.response?.status,
				data: err.response?.data
			}
		};
	}
};

export const baseApi = createApi({
	reducerPath: 'baseApi',
	baseQuery: axiosBaseQuery({
		baseUrl: process.env.REACT_APP_API_URL
	}),
	tagTypes: [],
	keepUnusedDataFor: 5,
	endpoints: () => ({})
});

export const axiosConfig = (method, url, data, isFormData) => {
	const baseUrl = process.env.REACT_APP_API_URL;
	const bearerToken = decryptData(localStorage.getItem('cayesh_user_loggged'))?.token;

	return axios({
		method,
		url: `${baseUrl}${url}`,
		data,
		headers: {
			authorization: `Bearer ${bearerToken}`,
			'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
			'Accept-Language': localStorage.getItem('i18nextLng')
		}
	})
		.then(response => {
			const { status, statusText, data } = response;
			if (status === 200) {
				return { error: false, message: statusText, status, data };
			}
			return { error: true, message: statusText, status };
		})
		.catch(err => {
			const { data } = err.response;
			if (data.message === 'Unauthenticated, Please send the OTP') {
				localStorage.clear();
				Navigate('login');
			}
			return { error: true, message: data.message, status: data.status, errors: data.errors };
		});
};
